import { render, staticRenderFns } from "./SelecionaAvaliadoResultado.vue?vue&type=template&id=4e710a84"
import script from "./SelecionaAvaliadoResultado.vue?vue&type=script&lang=js"
export * from "./SelecionaAvaliadoResultado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports